import {FlatList, Image, SafeAreaView, Text, TextInput, View} from "react-native";
import React, {useState, useEffect, useRef} from 'react'
import axios from "axios";
import styles from "./styles";
import Offer from "../Offer/Offer";
import {Banner, FAB} from 'react-native-paper';
import OfferBanner from "../OfferBanner/OfferBanner";
import HomeCategories from "../HomeCategories/HomeCategories";
import {useDispatch, useSelector} from "react-redux";
import { useRoute } from '@react-navigation/native';
import Constants from 'expo-constants';

const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

function OfferList(props) {

    const [hasError, setErrorFlag] = useState(false)
    const [IsLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState(false)
    const [search, setSearch] = useState('')
    const [fetching,setFetching] = useState(false)
    const [filteredDataSource, setFilteredDataSource] = useState([]);
    const [searchedDataSource, setSearchedDataSource] = useState([]);
    const [bannerVisible, setBannerVisible] = useState(false)
    const appData = props.appData;
    const app_id = appData.app_id;
    const url = `${baseUrl}/wp-json/custom/v1/offers?post_id=${app_id}`;
    let offers = useSelector(state=>state.offers.offers)

    const dispatch = useDispatch()

    const fetchOffers = async (search = '', user_id = '') => {
        setFetching(true)
        try {
            setIsLoading(true);
            let fetchUrl = url
            if(search){
                fetchUrl += '&search=' + search
            }
            if(user_id){
                fetchUrl += '&user_id=' + user_id
            }
            //cache buster
            fetchUrl += '&cb=' + Date.now()
            const response = await axios.get(fetchUrl);
            return await response;
        } catch (error) {
            if(axios.isCancel(error)){
                console.log('Data fetching cancelled');
            }else{
                console.log(error)
                setErrorFlag(true);
                setIsLoading(false);
            }
        }
    }
    const loadNewOffers = async(favourites = false) => {
        fetchOffers('', props.user.id).then(response => {
            setIsLoading(false)
            if (response.status === 200) {
                setCategories(response.data.categories)
                dispatch({
                    type: 'UPDATE_OFFERS',
                    payload: response.data,
                    favouritesFilter: props.favourites
                })
                let all_data = response.data.results
                if(props.category && all_data){
                    all_data = all_data.filter(function(offer){
                        return offer.categories.includes(props.category)
                    })
                }
                if(favourites){
                    all_data = all_data.filter(function(offer){
                        return offer.isFavourite
                    })
                }
                setFilteredDataSource(all_data)
                setSearchedDataSource(all_data)
            } else {
                console.log('error')
                throw new Error("Failed to fetch offers");
            }
        })
    }

    const onShare = async () => {
        console.log('sharing')
        let share_text = "Shop2Support " + props.appData.name  + ". Every purchase made here " + props.appData.app_link + " will provide direct proceeds to " + props.appData.name + ". Please take a look and share with your friends and followers if you like it!"
        if(navigator.share) {
            navigator.share({
                title: 'Shop2Support ' + props.appData.name,
                text: share_text,
                url: props.appData.app_link,
            })
        } else {
            props.navigation.navigate('SocialShare',{
                previousScreen: props.previousScreen,
                appData: props.appData,
                share_text: share_text,
                merge: true,
            })
        }
        /*
        NATIVE CODE
        const result = await Share.share({
            message: 'Shop2Support',
        });
        if (result.action === Share.sharedAction) {
            if (result.activityType) {
                // shared with activity type of result.activityType
            } else {
                // shared
            }
        } else if (result.action === Share.dismissedAction) {
            // dismissed
        }*/
    }

    const firstUpdate = useRef(true);
    const route = useRoute();


    useEffect(() => {
        setTimeout(() => {
            if (firstUpdate.current){
                setBannerVisible(true)
                firstUpdate.current = false
            }
        }, 5000)
        const source = axios.CancelToken.source()

        let favourites = !(route.name == 'Home')

        loadNewOffers(favourites).then(r => {
            console.log('load new offers done')
        })

        return () => source.cancel("Data fetching cancelled");
    },[props.user.id, props.category,route])

    const searchFilterFunction = (text) => {
        setSearch(text)
        if (text) {
            if(text.length > 2){
                setIsLoading(true)
                setFetching(true)
                fetchOffers(text).then(response => {
                    setFetching(false)
                    if (response.status === 200) {
                        setIsLoading(false)
                        setSearchedDataSource(response.data.results)
                        setFilteredDataSource(response.data.results)
                        return;
                    } else {
                        throw new Error("Failed to fetch offers");
                    }
                });
            } else if(text.length > 1) {
                console.log('reset search')
                setSearchedDataSource([])
                setFilteredDataSource(offers.results)
            }
        }
    }

    let categoryFilterFunction = (cat_id) => {
        setIsLoading(true)
        let cat_filter = searchedDataSource.filter(function(offer){
            return offer.categories.includes(cat_id)
        })
        setFilteredDataSource(cat_filter)
        setIsLoading(false)
    }

    let categoryClearFunction = () => {
        setIsLoading(true)
        setFilteredDataSource(offers.results)
        setIsLoading(false)
    }

    let showLoading = () => {
        return (
            <View style={{flex: 1, flexDirection: 'column'}}>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
                <Offer loading={true}/>
            </View>
        )
    }

    function showOfferPage(offerProps) {
        props.navigation.navigate('OfferDetails',{
            ...props,
            offer: offerProps,
            previousScreen: props.previousScreen,
            merge: true,
        })
    }

    const updateFavourite =  async(offerID) => {
        const postUrl = `${baseUrl}/wp-json/custom/v1/favourites`;
        const response = axios.post(postUrl,{
            user_id: props.user.id,
            offer_id: offerID
        })
        return response
    }

    function changeFavourite(index) {
        if(props.user.id){
            let tempData = [...filteredDataSource]
            if (!filteredDataSource[index].isFavourite) {
                tempData[index].isFavourite = true
                setFilteredDataSource(tempData)
            } else {
                tempData[index].isFavourite = false
                setFilteredDataSource(tempData)
            }
            updateFavourite(filteredDataSource[index].id,props.user.id).then(response => {
                let tempData = [...filteredDataSource]
                if (response.status == 200) {

                } else {

                    if (!filteredDataSource[index].isFavourite) {
                        tempData[index].isFavourite = false
                        setFilteredDataSource(tempData)
                    } else {
                        tempData[index].isFavourite = true
                        setFilteredDataSource(tempData)
                    }
                    throw new Error("Failed to fetch offers");
                }
            })
        } else {
            props.navigation.navigate('SignIn',{
                previousScreen: props.previousScreen,
                appData: props.appData,
                merge: true,
            })
        }
    }

    return (
            <SafeAreaView style={{flex:1,flexDirection:'column'}}>
                {!props.user.id ?
                    <Banner
                        visible={bannerVisible}
                        actions={[
                            {
                                label: 'Sign up',
                                onPress: () => props.navigation.navigate('SignUp', {appData: props.appData}),
                            },
                            {
                                label: 'Sign in',
                                onPress: () => props.navigation.navigate('SignIn', {
                                    appData: props.appData,
                                    previousScreen: 'Home'
                                }),
                            },
                            {
                                label: 'Dismiss',
                                onPress: () => {
                                    setBannerVisible(false)
                                },
                            },
                        ]}
                        icon={({size}) => (
                            <Image
                                source={{
                                    uri: props.appData.logo,
                                }}
                                style={{
                                    width: size,
                                    height: size,
                                }}
                            />
                        )}>
                        Are you a member yet?
                    </Banner> :
                    <></>
                }
                <FlatList
                    style={{flex:1}}
                    renderItem={({ item, index, separators }) => {
                        return(
                            <Offer
                                index={index}
                                id={item.id}
                                name={item.name}
                                description={item.description}
                                stickyHeaderIndices={[0]}
                                link={item.url}
                                imgsrc={item.image.url}
                                appData={props.appData}
                                Favourite={item.isFavourite}
                                loading={IsLoading}
                                showOffer={showOfferPage}
                                favouriteFunction={changeFavourite}
                                user={props.user}
                                previousScreen={props.previousScreen}
                                navigation={props.navigation}
                            />
                        )
                    }}
                    ListHeaderComponent={
                        !props.favourites ?
                        <View style={{flex: 1}}>
                            <View style={{width:'100%',height:undefined,aspectRatio: 5/7 }}>
                                <OfferBanner appData={props.appData}/>
                            </View>
                            <View style={styles.searchContainer}>
                                <TextInput
                                    style={styles.input}
                                    placeholder="Search"
                                    clearButtonMode="always"
                                    onChangeText={(text) => searchFilterFunction(text)}
                                    value={search}
                                />
                            </View>
                            <View style={styles.categoryContainer}>
                                <HomeCategories loading={IsLoading} catData={categories} filterFunction={categoryFilterFunction} clearFunction={categoryClearFunction}/>
                            </View>
                            <View>

                            </View>
                        </View>
                            : <View style={{marginBottom:60}}></View>
                    }
                    data={filteredDataSource}
                    keyExtractor={(item) => item.id}
                    initialNumToRender={10}
                    ListEmptyComponent={IsLoading ? showLoading: <Text style={styles.loading}>No results</Text>}
                    extraData={filteredDataSource}
                >
                </FlatList>
                <FAB
                    icon="share"
                    label="share"
                    style={[styles.fab,{backgroundColor:props.appData.theme_colour}]}
                    onPress={onShare}
                />
            </SafeAreaView>
        )
}

export default OfferList;